import type { TaxIdType } from "./TaxIdType";
import { taxIdTypes } from "./taxIdTypes/index";

export const areThereAnyTaxIdsForCountry = (countryCode: string) =>
  taxIdTypes.some(t => t.countryCode === countryCode);

export const isValidTaxIdValue = (taxIdEnum: string, taxIdValue: string) => {
  const taxIdType = taxIdTypes.find(t => t.enum === taxIdEnum);
  if (!taxIdType) {
    return false;
  }
  if (taxIdType.formOptions?.pattern) {
    return taxIdType.formOptions.pattern.test(taxIdValue);
  }
  return true;
};

export const mapTaxIdTypeToOptions = (entry: TaxIdType) => ({
  value: entry.label,
  text: entry.label,
});

const taxIdTypeLabelByTaxIdTypeAndCountryCode: Record<string, TaxIdType> =
  taxIdTypes.reduce((dict: Record<string, TaxIdType>, entry: TaxIdType) => {
    dict[`${entry.enum}-${entry.countryCode}`] = entry;
    return dict;
  }, {});
export const getTaxIdTypeLabelByTaxIdTypeAndCountryCode = (
  taxIdType: string | undefined,
  countryCode: string | undefined,
) =>
  taxIdTypeLabelByTaxIdTypeAndCountryCode[`${taxIdType}-${countryCode}`]
    ?.label ?? "";

const taxIdTypesByLabel: Record<string, TaxIdType> = taxIdTypes.reduce(
  (dict: Record<string, TaxIdType>, entry: TaxIdType) => {
    dict[entry.label] = entry;
    return dict;
  },
  {},
);
export const getTaxIdTypeByLabel = (label: string | undefined) =>
  taxIdTypesByLabel[label ?? ""];

const taxIdTypesByType: Record<string, TaxIdType> = taxIdTypes.reduce(
  (dict: Record<string, TaxIdType>, entry: TaxIdType) => {
    dict[entry.enum] = entry;
    return dict;
  },
  {},
);
export const getTaxIdLabelByType = (type: string | undefined) =>
  taxIdTypesByType[type ?? ""]?.label;

export const filterTaxIdTypeOptionBySearchValue = (
  option: { value: string; text: string },
  searchValue: string,
) => {
  const searchValueLower = searchValue.toLowerCase();
  return (
    option.value.toLowerCase().includes(searchValueLower) ||
    option.text.toLowerCase().includes(searchValueLower)
  );
};

export const getBrazilCpfTaxIdType = () =>
  taxIdTypes.find(type => type.enum === "br_cpf");
